module.exports = __webpack_public_path__ + "static/media/gas_01.f7e69abb.svg";